import { createSelector } from 'reselect'
import { ReduxState } from 'store/createRootReducer'
import { UpdateLandingsTask, TasksQueueState } from '../types'
import featureStateSelector from './featureStateSelector'

export const updateLandingsTasksSelector = createSelector<ReduxState, TasksQueueState, UpdateLandingsTask[]>(
  featureStateSelector,
  state => {
    const { pages, currentPage } = state.updateLandingsTasksPagination
    return (pages[currentPage] || []).map(id => state.updateLandingTasks[id])
  }
)
